import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import white2 from "../images/image/PAREAGON 43.jpg";
import white from "../images/image/PAREAGON 107.jpg";
import white1 from "../images/image/PAREAGON 58.jpg";
import white3 from "../images/image/PAREAGON 161.jpg";

import red from "../images/image/PAREAGON 86.jpg";
import red3 from "../images/image/PAREAGON 159.jpg";
import red1 from "../images/image/PAREAGON 70.jpg";
import red2 from "../images/image/PAREAGON 20.jpg";
import red5 from "../images/image/Burgundy.jpg";
import red4 from "../images/image/Burgundy2.jpg";
import red6 from "../images/image/Burgundy3.jpg";



import beige from "../images/beige.JPEG";
import noir from "../images/noir.JPEG";
import topB from "../images/PARAGON-27.jpg";
import blackw from "../images/image/PAREAGON 97.jpg";
import black from "../images/image/PARAEGON 42.jpg";

import noir1 from "../images/noir1.png";
import noir2 from "../images/noir2.png";
import topB1 from "../images/PARAGON-26.jpg";
import topB2 from "../images/PARAGON-29.jpg";
import topB3 from "../images/PARAGON-28.jpg";
import blackw1 from "../images/image/PAREAGON 63.jpg";
import blackw2 from "../images/image/PAREAGON 33.jpg";
import blackw3 from "../images/image/PAREAGON 164.jpg";
import blackw4 from "../images/White:black.jpg";
import blackw5 from "../images/White:black2.jpg";
import blackw6 from "../images/White:black3.jpg";
import black1 from "../images/image/PARAEGON 23.jpg";
import black2 from "../images/image/PARAEGON 13.jpg";
import black3 from "../images/image/PARAEGON 46.jpg";
import black4 from "../images/image/Black.jpg";
import black5 from "../images/image/Black2.jpg";



import b1 from "../images/b1.png";
import b2 from "../images/b2.png";
import crimson from "../images/solo2.JPG";

import { useCart } from "../pages/CartContext";

const SOLD_OUT_MODE = false;

const urlSoldOut =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("soldout") === "1";

const soldOutMode = SOLD_OUT_MODE || urlSoldOut;

const productData = {
  gray: {
    name: "WHITE PΛREΛGON RUNNERS",
    displayName: "White Go Runners",
    price: "$1,050 USD",
    color: "White",
    images: [white, white1, white2, white3],
    sizes: {
      men: [3, 4, 5, 6, 7, 8, 9, 10, 11],
      women: [5, 6, 7, 8, 9, 10, 11, 12, 13],
      eu: [35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
    },
    stock: true,
    sku: "GO-RUNNERS-WHT",
  },

  yellow: {
    name: "BURGUNDY PΛREΛGON RUNNER",
    displayName: "BurgundyRunners",
    price: "$1,050 USD",
    color: "Burgundy",
    images: [red, red1, red2, red3, red4, red5, red6],
    sizes: {
      men: [3, 4, 5, 6, 7, 8, 9, 10, 11],
      women: [5, 6, 7, 8, 9, 10, 11, 12, 13],
      eu: [35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
    },
    stock: true,
    sku: "BURGUNDY-RUNNERS-860",
  },

  topwhite: {
    name: "WHITE/BLACK PΛREΛGON RUNNERS",
    displayName: "White/Black PΛREΛGON RUNNERS",
    price: "$1,050 USD",
    color: "White/Black",
    images: [blackw, blackw1, blackw2, blackw3, blackw4, blackw5, blackw6],
    sizes: {
      men: [3, 4, 5, 6, 7, 8, 9, 10, 11],
      women: [5, 6, 7, 8, 9, 10, 11, 12, 13],
      eu: [35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
    },
    stock: true,
    sku: "RUNNERS-WHTBLK",
  },

  black: {
    name: "BLACK PΛREΛGON RUNNERS",
    displayName: "Black Runners",
    price: "$1,050 USD",
    color: "Black/Silver",
    images: [black, black1, black2, black3, black4, black5],
    sizes: {
      men: [3, 4, 5, 6, 7, 8, 9, 10, 11],
      women: [5, 6, 7, 8, 9, 10, 11, 12, 13],
      eu: [35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
    },
    stock: true,
    sku: "RUNNERS-BLCK",
  },

  beige: {
    name: "PΛREΛGON GO RUNNERS BEIGE",
    displayName: "Beige Go Runners",
    price: "$550 USD",
    color: "Beige/White",
    images: [beige, b1, b2],
    sizes: {
      men: [6, 7, 8, 9, 10, 11],
      women: [8, 9, 10, 11, 12, 13],
      eu: [39, 40, 41, 42, 43, 44],
    },
    stock: true,
    sku: "GO-RUNNERS-BGE",
  },

  noir: {
    name: "PΛREΛGON NOIR OFF WHITE",
    displayName: "Noir Off White",
    price: "$550 USD",
    color: "Black/White",
    images: [noir, noir1, noir2],
    sizes: {
      men: [7, 8, 9, 10],
      women: [9, 10],
      eu: [40, 41, 42, 43],
    },
    stock: true,
    sku: "NOIR-OFF-WHITE",
  },

  topbeige: {
    name: "BEIGE/BLUE PΛREΛGON TOPSIDE",
    displayName: "Topside Beige",
    price: "$550 USD",
    color: "Beige/Black",
    images: [topB, topB1, topB2, topB3],
    sizes: {
      men: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      women: [5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13],
      eu: [37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
    },
    stock: true,
    sku: "TOPSIDE-BEIGE",
  },

  crimson: {
    name: "PΛREΛGON Crimson",
    displayName: "crimson",
    price: "$1,050 USD",
    color: "crimson/White",
    images: [crimson],
    sizes: {
      women: [7, 7.5, 8, 8.5, 9, 9.5],
    },
    stock: true,
    sku: "PΛREAGON-CRIMSON",
  },
};

const sizeConversions = {
  35: { eu: 35, men: 3, women: 5 },
  36: { eu: 36, men: 4, women: 6 },
  37: { eu: 37, men: 5, women: 7 },
  38: { eu: 38, men: 6, women: 8 },
  39: { eu: 39, men: 7, women: 9 },
  40: { eu: 40, men: 8, women: 10 },
  41: { eu: 41, men: 9, women: 11 },
  42: { eu: 42, men: 10, women: 12 },
  43: { eu: 43, men: 11, women: 13 },
  44: { eu: 44, men: 12, women: 14 },
};

const convertToEuSize = (size, sizeType) => {
  if (
    sizeType === "women" &&
    (size === 7 ||
      size === 7.5 ||
      size === 8 ||
      size === 8.5 ||
      size === 9 ||
      size === 9.5)
  ) {
    return size;
  }

  const conversion = Object.values(sizeConversions).find(
    (conv) => conv[sizeType] === size || conv[sizeType] === parseFloat(size)
  );

  return conversion ? conversion.eu : null;
};

const ProductPage = () => {
  const { id } = useParams();
  const product = productData[id];
  const { addToCart } = useCart();

  const [inventory, setInventory] = useState([]);
  const [inventoryLoading, setInventoryLoading] = useState(true);

  const [selectedImage, setSelectedImage] = useState(product?.images[0]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [gender, setGender] = useState("men");
  const [showToast, setShowToast] = useState(false);
  const [lastAdded, setLastAdded] = useState(null);

  const initialInventoryData = useMemo(
    () => [
      { product: "White Go Runners", size: "35", stock: 2 },
      { product: "White Go Runners", size: "36", stock: 2 },
      { product: "White Go Runners", size: "37", stock: 2 },
      { product: "White Go Runners", size: "38", stock: 2 },
      { product: "White Go Runners", size: "39", stock: 2 },
      { product: "White Go Runners", size: "40", stock: 2 },
      { product: "White Go Runners", size: "41", stock: 2 },
      { product: "White Go Runners", size: "42", stock: 2 },
      { product: "White Go Runners", size: "43", stock: 2 },
      { product: "White Go Runners", size: "44", stock: 2 },

      { product: "BurgundyRunners", size: "35", stock: 1 },
      { product: "BurgundyRunners", size: "36", stock: 2 },
      { product: "BurgundyRunners", size: "37", stock: 2 },
      { product: "BurgundyRunners", size: "38", stock: 2 },
      { product: "BurgundyRunners", size: "39", stock: 2 },
      { product: "BurgundyRunners", size: "40", stock: 2 },
      { product: "BurgundyRunners", size: "41", stock: 2 },
      { product: "BurgundyRunners", size: "42", stock: 2 },
      { product: "BurgundyRunners", size: "43", stock: 2 },
      { product: "BurgundyRunners", size: "44", stock: 2 },

      { product: "White/Black PΛREΛGON RUNNERS", size: "35", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "36", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "37", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "38", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "39", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "40", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "41", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "42", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "43", stock: 2 },
      { product: "White/Black PΛREΛGON RUNNERS", size: "44", stock: 2 },

      { product: "Black Runners", size: "35", stock: 2 },
      { product: "Black Runners", size: "36", stock: 2 },
      { product: "Black Runners", size: "37", stock: 2 },
      { product: "Black Runners", size: "38", stock: 2 },
      { product: "Black Runners", size: "39", stock: 2 },
      { product: "Black Runners", size: "40", stock: 2 },
      { product: "Black Runners", size: "41", stock: 2 },
      { product: "Black Runners", size: "42", stock: 2 },
      { product: "Black Runners", size: "43", stock: 2 },
      { product: "Black Runners", size: "44", stock: 2 },

      { product: "Beige Go Runners", size: "39", stock: 2 },
      { product: "Beige Go Runners", size: "40", stock: 2 },
      { product: "Beige Go Runners", size: "41", stock: 2 },
      { product: "Beige Go Runners", size: "42", stock: 2 },
      { product: "Beige Go Runners", size: "43", stock: 2 },
      { product: "Beige Go Runners", size: "44", stock: 2 },

      { product: "Noir Off White", size: "40", stock: 1 },
      { product: "Noir Off White", size: "41", stock: 2 },
      { product: "Noir Off White", size: "42", stock: 2 },
      { product: "Noir Off White", size: "43", stock: 3 },

      { product: "Topside Beige", size: "37", stock: 2 },
      { product: "Topside Beige", size: "38", stock: 6 },
      { product: "Topside Beige", size: "39", stock: 4 },
      { product: "Topside Beige", size: "40", stock: 8 },
      { product: "Topside Beige", size: "41", stock: 7 },
      { product: "Topside Beige", size: "42", stock: 5 },
      { product: "Topside Beige", size: "43", stock: 3 },
      { product: "Topside Beige", size: "44", stock: 6 },
      { product: "Topside Beige", size: "45", stock: 4 },
      { product: "Topside Beige", size: "46", stock: 2 },

      { product: "crimson", size: "7", stock: 1 },
      { product: "crimson", size: "7.5", stock: 1 },
      { product: "crimson", size: "8", stock: 1 },
      { product: "crimson", size: "8.5", stock: 1 },
      { product: "crimson", size: "9", stock: 1 },
      { product: "crimson", size: "9.5", stock: 1 },
    ],
    []
  );

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        setInventoryLoading(true);
        const response = await fetch("https://shoe-website-p3no.onrender.com/inventory");

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const inventoryData = data.length > 0 ? data : initialInventoryData;
        setInventory(inventoryData);
      } catch (error) {
        console.error("Error fetching inventory:", error);
        setInventory(initialInventoryData);
      } finally {
        setInventoryLoading(false);
      }
    };

    fetchInventory();

    const interval = setInterval(fetchInventory, 30000);
    return () => clearInterval(interval);
  }, [initialInventoryData]);

  const getStock = (size) => {
    if (soldOutMode) return 0;
    if (!product?.displayName || !Array.isArray(inventory)) return 0;

    if (product.displayName === "crimson") {
      const item = inventory.find((item) => {
        if (!item.product || !item.size) return false;

        const itemName = item.product.toLowerCase().trim();
        const itemSize = parseFloat(item.size);
        const requestedSize = parseFloat(size);

        return itemName === "crimson" && itemSize === requestedSize;
      });

      return item ? item.stock || 0 : 0;
    }

    const euSize = convertToEuSize(size, gender);
    if (!euSize) return 0;

    const item = inventory.find((item) => {
      if (!item.product || !item.size) return false;

      const itemName = item.product.toLowerCase().trim();
      const productNameLower = product.displayName.toLowerCase().trim();
      const itemSize = parseInt(item.size, 10);

      if (itemSize !== euSize) return false;

      return itemName === productNameLower;
    });

    return item ? item.stock || 0 : 0;
  };

  const isInStock = (size) => getStock(size) > 0;

  const isProductInStock = () => {
    if (!product?.displayName || !Array.isArray(inventory)) return false;
    return product.sizes[gender].some((size) => isInStock(size));
  };

  const isProductLowStock = () => {
    if (!product?.displayName || !Array.isArray(inventory)) return false;

    const sizesForCurrentType = product.sizes[gender] || [];
    const inStockSizes = sizesForCurrentType.filter((size) => getStock(size) > 0);

    if (inStockSizes.length === 0) return false;

    return inStockSizes.every((size) => getStock(size) <= 3);
  };

  if (!product) return <div className="p-8">Product not found.</div>;

  const handleAddToCart = () => {
    if (!selectedSize) return alert("Please select a size.");
    if (!isInStock(selectedSize)) return alert("This size is out of stock.");

    addToCart({ ...product, sizeType: gender }, selectedSize);
    setLastAdded({ ...product, selectedSize, sizeType: gender });
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const stockStatus = isProductInStock();
  const lowStockStatus = isProductLowStock();

  return (
    <div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-2 gap-12 font-sans relative">
      <div>
        <div className="grid grid-cols-6 gap-2 mb-4">
          {product.images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`Thumbnail ${i}`}
              className={`aspect-square w-full object-cover border ${
                selectedImage === img ? "border-black" : "border-gray-200"
              } cursor-pointer`}
              onClick={() => setSelectedImage(img)}
            />
          ))}
        </div>

        <img
          src={selectedImage}
          alt={product.name}
          className="w-full object-contain"
        />
      </div>

      <div>
        <h1 className="text-2xl font-bold mb-2">{product.name}</h1>
        <p className="text-lg font-semibold text-gray-800 mb-2">{product.price}</p>
        <p className="mb-4">Color: {product.color}</p>

        {inventoryLoading ? (
          <p className="text-sm mb-2 text-gray-500">Loading stock information...</p>
        ) : (
          <div className="mb-2">
            <p className="text-sm">
              {stockStatus ? (
                <span className="text-green-600 font-semibold">✓ In Stock</span>
              ) : (
                <span className="text-red-500 font-semibold">✗ Out of Stock</span>
              )}
            </p>

            {stockStatus && lowStockStatus && (
              <p className="text-xs text-orange-600 font-medium mt-1">
                Running Low
              </p>
            )}
          </div>
        )}

        <p className="text-xs text-gray-500 mb-4">SKU: {product.sku}</p>

        <div className="flex gap-2 mb-4">
          {Object.keys(product.sizes).map((g) => (
            <button
              key={g}
              onClick={() => {
                setGender(g);
                setSelectedSize(null);
              }}
              className={`px-3 py-1 rounded ${
                gender === g ? "bg-black text-white" : "bg-gray-200"
              }`}
            >
              {g.charAt(0).toUpperCase() + g.slice(1)}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-4 gap-2 mb-6">
          {product.sizes[gender].map((size) => {
            const sizeStock = getStock(size);
            const sizeInStock = sizeStock > 0;
            const euEquivalent =
              product.displayName === "crimson"
                ? size
                : convertToEuSize(size, gender);

            return (
              <button
                key={size}
                onClick={() => sizeInStock && setSelectedSize(size)}
                disabled={!sizeInStock}
                className={`py-2 border text-sm relative overflow-hidden ${
                  selectedSize === size
                    ? "border-black bg-gray-100"
                    : sizeInStock
                    ? "border-gray-300 hover:border-black"
                    : "border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed"
                }`}
                title={
                  sizeInStock
                    ? `${sizeStock} in stock ${
                        product.displayName !== "crimson" ? `(EU ${euEquivalent})` : ""
                      }`
                    : "Out of stock"
                }
              >
                <span className={sizeInStock ? "" : "relative z-10"}>{size}</span>

                {!sizeInStock && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-3/4 h-0.5 bg-red-400 transform rotate-45"></div>
                  </div>
                )}
              </button>
            );
          })}
        </div>

        <button
          onClick={handleAddToCart}
          disabled={!selectedSize || !isInStock(selectedSize) || !stockStatus}
          className={`w-full py-3 rounded-full font-medium transition-colors ${
            !selectedSize || !isInStock(selectedSize) || !stockStatus
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-black text-white hover:bg-gray-800"
          }`}
        >
          {!stockStatus
            ? "Out of Stock"
            : !selectedSize
            ? "Select a Size"
            : !isInStock(selectedSize)
            ? "Size Out of Stock"
            : "Add to Bag"}
        </button>
      </div>

      {showToast && lastAdded && (
        <div className="fixed bottom-6 right-6 bg-white border border-gray-300 shadow-lg rounded-lg p-4 flex items-center gap-4 z-50 transition-all">
          <img
            src={lastAdded.images[0]}
            alt={lastAdded.name}
            className="w-16 h-16 object-cover rounded"
          />
          <div>
            <p className="font-semibold">Added to Bag</p>
            <p className="text-sm text-gray-600">{lastAdded.name}</p>
            <p className="text-xs text-gray-400">
              Size: {lastAdded.selectedSize} ({lastAdded.sizeType})
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductPage;